import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "step3-container"
};
const _hoisted_2 = {
  class: "step3-row"
};
const _hoisted_3 = {
  class: "step3-row"
};
const _hoisted_4 = {
  class: "step3-row"
};
import { reactive, ref, watch } from "vue";
import { COUNTRY_LIST } from "@/const";
export default {
  __name: 'step-3',
  props: {
    rules: {
      type: Object,
      required: true
    }
  },
  emits: ["update:form", "update:form-blur"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const formRef = ref(null);
    const form = reactive({
      streetAddress: "",
      city: "",
      zipCode: "",
      country: "",
      state: ""
    });
    const isFocused = reactive({
      streetAddress: false,
      city: false,
      zipCode: false,
      country: false,
      state: false
    });
    const handleFormBlur = () => {
      isFocused.streetAddress = false;
      isFocused.city = false;
      isFocused.zipCode = false;
      isFocused.country = false;
      isFocused.state = false;
      emit("update:form-blur");
    };
    watch(form, () => {
      emit("update:form", form);
    }, {
      deep: true,
      immediate: true
    });
    const validate = () => {
      return formRef.value?.validate();
    };
    // Expose validation method to parent component
    __expose({
      validate
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "step3-title"
      }, [_createTextVNode("Step "), _createElementVNode("span", null, "3"), _createTextVNode(":")], -1)), _cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "step3-subtitle"
      }, "Enter your billing address", -1)), _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        class: "step3-form",
        model: form,
        rules: __props.rules
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
          prop: "streetAddress",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.streetAddress || form.streetAddress
          }])
        }, {
          default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "float-label"
          }, "Street address", -1)), _createVNode(_component_el_input, {
            modelValue: form.streetAddress,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.streetAddress = $event),
            onFocus: _cache[1] || (_cache[1] = $event => isFocused.streetAddress = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1,
          __: [10]
        }, 8, ["class"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form_item, {
          prop: "city",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.city || form.city
          }])
        }, {
          default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("label", {
            class: "float-label"
          }, "City", -1)), _createVNode(_component_el_input, {
            modelValue: form.city,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.city = $event),
            onFocus: _cache[3] || (_cache[3] = $event => isFocused.city = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1,
          __: [11]
        }, 8, ["class"]), _createVNode(_component_el_form_item, {
          prop: "zipCode",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.zipCode || form.zipCode
          }])
        }, {
          default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("label", {
            class: "float-label"
          }, "Postal Code", -1)), _createVNode(_component_el_input, {
            modelValue: form.zipCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.zipCode = $event),
            onFocus: _cache[5] || (_cache[5] = $event => isFocused.zipCode = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1,
          __: [12]
        }, 8, ["class"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form_item, {
          prop: "country",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.country || form.country
          }])
        }, {
          default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("label", {
            class: "float-label"
          }, "Country", -1)), _createVNode(_component_el_select, {
            modelValue: form.country,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.country = $event),
            onFocus: _cache[7] || (_cache[7] = $event => isFocused.country = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COUNTRY_LIST), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.code,
                label: item.name,
                value: item.name
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1,
          __: [13]
        }, 8, ["class"]), _createVNode(_component_el_form_item, {
          prop: "state",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.state || form.state
          }])
        }, {
          default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("label", {
            class: "float-label"
          }, "State/Province", -1)), _createVNode(_component_el_input, {
            modelValue: form.state,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.state = $event),
            onFocus: _cache[9] || (_cache[9] = $event => isFocused.state = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1,
          __: [14]
        }, 8, ["class"])])]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
};